/**
 * 파일명: aboutVisual.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us - 히어로
 */
import React from "react";
import { useMediaQuery } from "react-responsive";
import useAboutBg from "components/about/aboutAsset";
import style from "css/about.module.css";

function AboutVisual() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const bg = useAboutBg();

  return (
    <section
      className={style.ab_hero}
      style={bg("hero")}
    >
      <div className={style.ab_hero_inner}>
        <h1 className={style.ab_hero_title}>
          We Deliver
          <br />
          Innovative Technology
        </h1>

        <p className={style.ab_hero_desc}>
          리브테크놀로지는 최첨단 기술과{isMobile ? <br /> : " "}
          맞춤형 서비스를 기반으로
          <br />
          고객의 비즈니스 성장을 지원하며{isMobile ? <br /> : " "}
          다양한 산업 분야에서 신뢰받는 파트너로{isMobile ? <br /> : " "}
          자리매김하고 있습니다.
        </p>
      </div>
    </section>
  );
}

export default AboutVisual;
